import React from 'react'

import { Label } from '@/shared/components/atoms/Label/Label'

import { BankFieldProps } from './PaymentMethods.types'
import { hasValue } from './PaymentMethods.utils'

export const BankField: React.FC<BankFieldProps> = React.memo(
	({ label, value, fieldId }) => {
		if (!hasValue(value)) return null

		return (
			<div className="space-y-2">
				<Label htmlFor={fieldId} className="text-muted-foreground">
					{label}
				</Label>
				<p className="text-foreground">{value}</p>
			</div>
		)
	}
)

BankField.displayName = 'BankField'
